const RequiredMark = () => (
  <span className='text-red-500' aria-hidden>
    *
  </span>
);

export default RequiredMark;
